import PropTypes from 'prop-types'
import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../common/html/checkbox'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Radio } from '../../../common/html/radio'
import { Loading } from '../../../common/loading'
import { PopupAction } from '../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../common/scrollComponent'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentNonBank,
} from './constant'
import { getSettingPanel } from './helper'
import classes from './index.module.scss'
import { keyLoading, selectIndicatorById, selectLoading } from './store/slice'
import { getIndicatorPanel } from './store/thunk'

const SettingPanel = ({ panel, defaultPanel, setValue }) => {
  const dispatch = useDispatch()

  const setting = getSettingPanel(panel?.key)

  const locale = useSelector((state) => state.i18n.locale)
  const indicatorById = useSelector(selectIndicatorById)
  const loading = useSelector(selectLoading(keyLoading.INDICATOR))

  const [isShowPopupReset, setIsShowPopupReset] = useState(false)

  useEffect(() => {
    if ((setting.companyType, setting.ratioGroupCode)) {
      dispatch(
        getIndicatorPanel({
          GroupCode: setting.ratioGroupCode,
          CompanyType: setting.companyType,
        }),
      )
    }
  }, [locale, setting.ratioGroupCode, setting.companyType])

  const setViewBy = (value) => setValue('viewByActive', value)

  const setDefault = () => {
    Object.keys(defaultPanel).forEach((key) => {
      setValue(key, defaultPanel[key])
    })
    setIsShowPopupReset(false)
  }

  const changeChecked = (id) => (isCheck) => {
    const checked = [...panel.setting.checked]
    if (isCheck) {
      checked.push(id)
      setValue('setting.checked', checked)
    } else {
      setValue(
        'setting.checked',
        checked.filter((idChecked) => idChecked !== id),
      )
    }
  }

  if (!panel) {
    return
  }

  return (
    <div className={classes.panelList}>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="dFlex alignItemsCenter">
            <Element
              style={{ fontSize: 14, color: '#191D25' }}
              className={`${classes.title} w100`}
            >
              <Translate value={panel.label} />
            </Element>
            <Element
              style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
              className={classes.btnReset}
              onClick={() => setIsShowPopupReset(true)}
            >
              <Icon
                style={{ color: '#0553A5', fontSize: 13 }}
                className="icon-reset2"
              />
              <Translate value="preferenceSetting.RESET" />
            </Element>
          </div>
          <div className={`${classes.note} pt1`}>
            <Translate value="financialAnalysis.PANEL_SETTING_NOTE" />
          </div>
          <div className={classes.contentSetting}>
            {[
              typeComponentCorporate.QUICK_ASSESSMENT,
              typeComponentBank.QUICK_ASSESSMENT,
              typeComponentNonBank.QUICK_ASSESSMENT,
            ].includes(panel.key) ? (
              <div className="dFlex alignItemsCenter">
                <Icon
                  className="icon-info-circle mr1"
                  style={{ fontSize: 20, color: '#9C9C9C' }}
                />
                <div>
                  <Translate value="financialAnalysis.QUICK_ASSESSMENT_NOTE" />
                </div>
              </div>
            ) : (
              <ScrollComponent>
                <Element
                  className={classes.viewBy}
                  style={{ background: '#F3F3F3' }}
                >
                  <div className={classes.label}>
                    <Translate value="financialAnalysis.VIEW_BY" />
                  </div>
                  <div className={`dFlex ${classes.radios}`}>
                    {panel.viewByList.map((value, index) => {
                      return (
                        <Radio
                          key={value}
                          mlTitle={5}
                          appendStyle={{
                            marginLeft: index !== 0 ? '40px' : '0px',
                          }}
                          title={`financialAnalysis.${value}`}
                          value={value}
                          activeValue={panel.viewByActive}
                          onChange={setViewBy}
                          isI18n
                          titleStyle={{ whiteSpace: 'nowrap' }}
                        />
                      )
                    })}
                  </div>
                </Element>
                <Element
                  className={classes.setting}
                  style={{ background: '#F3F3F3' }}
                >
                  <div className={classes.label}>
                    <Translate value="financialAnalysis.INFORMATION" />
                  </div>
                  <div>
                    <i>
                      <Translate value="financialAnalysis.INFORMATION_NOTE" />
                    </i>
                  </div>
                  {setting[panel.viewByActive].map(
                    ({ label, indicators }, index) => {
                      return (
                        <Fragment key={index}>
                          <div className="mt1">
                            {label && (
                              <>
                                &#8226;&nbsp;&nbsp;
                                <Translate value={label} />
                              </>
                            )}
                          </div>
                          <div style={{ paddingLeft: label ? '13px' : '0px' }}>
                            <div className={classes.mt4}>
                              {indicators.map(({ id, enable }) => {
                                const isChecked =
                                  !enable || panel.setting.checked?.includes(id)
                                const isAllowChange =
                                  !!enable &&
                                  (panel.setting.checked.length > 1 ||
                                    !isChecked)

                                return (
                                  <div
                                    key={panel.viewByActive + id}
                                    className={classes.mt4}
                                  >
                                    <Checkbox
                                      title={indicatorById[id]?.ratioName}
                                      isCheckOnClickText
                                      style={{ marginLeft: 6 }}
                                      allowChange={isAllowChange}
                                      checked={isChecked}
                                      onChange={changeChecked(id)}
                                    />
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </Fragment>
                      )
                    },
                  )}
                </Element>
              </ScrollComponent>
            )}
          </div>
          <PopupAction
            isShow={isShowPopupReset}
            title="preferenceSetting.CONFIRMATION_2"
            handleClose={() => setIsShowPopupReset(false)}
            btnCancel={{
              label: 'common.NO',
              event: () => setIsShowPopupReset(false),
              isI18n: true,
            }}
            btnSubmit={{
              label: 'common.YES',
              event: setDefault,
              isI18n: true,
            }}
          >
            <Translate value="preferenceSetting.RESET_TEMPLATE" />
          </PopupAction>
        </>
      )}
    </div>
  )
}

SettingPanel.propTypes = {
  panel: PropTypes.object,
}

export default SettingPanel
